import React from 'react';
import { LocalFrame, CentralFrame } from '../../model/CollectiveAgreement';
import { Table, TableHead, TableBody, TableRow, TableCell, Typography, Button, Box } from '@mui/material';


interface LocalFrameProps {
  item?: LocalFrame;
  CentralFrame?: CentralFrame;
}

const months = ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "Desember"];

export const LocalFrameTable = ({ item, CentralFrame }: LocalFrameProps) => {
  const renderValue = (val: number, isPercent?: boolean) =>
    val === 0 ? '-' : isPercent ? `${val.toFixed(2)} %` : `kr ${val.toFixed(2)}`;

  const renderMonth = (monthIndex: number) =>
    months[monthIndex] || '-';

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Lokal ramme</Typography>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: 'grey.900' }}>
            <TableCell />
            <TableCell colSpan={3} align="center">Årslønnsvekst</TableCell>
            {!CentralFrame.no_central_overhang && (
              <TableCell colSpan={3} align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>
                Datovekst
              </TableCell>
            )}
          </TableRow>
          <TableRow>
            <TableCell />
            <TableCell />
            <TableCell align="center">Kr pr time</TableCell>
            <TableCell align="center">Prosent</TableCell>
            {!CentralFrame.no_central_overhang && (
              <>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>Kr pr time</TableCell>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>Prosent</TableCell>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>Virkningsdato</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {!CentralFrame.no_central_overhang && (
            <>
              <TableRow>
                <TableCell>Sentralt overheng</TableCell>
                <TableCell />
                {/* <TableCell align="center">{renderValue(item.cao.val)}</TableCell>
                <TableCell align="center">{renderValue(item.cao.percent, true)}</TableCell> */}
                {/* <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdo.val)}</TableCell>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdo.percent, true)}</TableCell>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderMonth(item.cdo.month)}</TableCell> */}
              </TableRow>

              <TableRow>
                <TableCell>Sentrale generelle tillegg</TableCell>
                <TableCell />
                {/* <TableCell align="center">{renderValue(item.cag.val)}</TableCell>
                <TableCell align="center">{renderValue(item.cag.percent, true)}</TableCell>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdg.val)}</TableCell>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdg.percent, true)}</TableCell>
                <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderMonth(item.cdg.month)}</TableCell> */}
              </TableRow>
            </>
          )}

          {CentralFrame.low_salary_active && !CentralFrame.no_central_overhang && (
            <TableRow>
              <TableCell>
                {CentralFrame.low_salary_rename ? 'Andre tillegg' : 'Sentralt lavlønnstillegg'}
              </TableCell>
              <TableCell />
              {/* <TableCell align="center">{renderValue(item.calv.val)}</TableCell>
              <TableCell align="center">{renderValue(item.calv.percent, true)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdlv.val)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdlv.percent, true)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderMonth(item.cdlv.month)}</TableCell> */}
            </TableRow>
          )}

          {CentralFrame.guarantee_active && (
            <TableRow>
              <TableCell>Garantitillegg</TableCell>
              <TableCell />
              {/* <TableCell align="center">{renderValue(item.cga.val)}</TableCell>
              <TableCell align="center">{renderValue(item.cga.percent, true)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cgav.val)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cgav.percent, true)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderMonth(item.cgav.month)}</TableCell> */}
            </TableRow>
          )}

          {!CentralFrame.no_central_overhang && (
            <TableRow>
              <TableCell>Glidning / lokale tillegg</TableCell>
              <TableCell />
              {/* <TableCell align="center">{renderValue(item.cagl.val)}</TableCell>
              <TableCell align="center">{renderValue(item.cagl.percent, true)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdgl.val)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderValue(item.cdgl.percent, true)}</TableCell>
              <TableCell align="center" sx={{ backgroundColor: '#909090', color: '#fff' }}>{renderMonth(item.cdgl.month)}</TableCell> */}
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Typography sx={{ mt: 2 }}>
        {/* Snittlønn for tariffområdet: <b style={{ textDecoration: 'underline' }}>kr {item.ed_avg.toFixed(2)} pr time</b> */}
      </Typography>
    </Box>
  );
};
